// userService.js
import { post } from './common';


export const authenticate = (userData) => {
  return post('auth/signin', userData);
};

export const forgotPassword = (userData) => {
    return post('auth/forget-password', userData);
};

export const resetPassword = (userData,token) => {
  return post('auth/reset-password/'+token, userData);
};

export const verifyResetPasswordToken = (token) => {
  return post('auth/verify-reset-password/'+token,{'resetToken': token});
};

export const clientRegister = (userData) => {
  return post('auth/register-client', userData);
};
